import React from "react";
import "./IconModification.css";

const KeyBoard = () => {
  return (
    <div>
      <svg
        className="Icons"
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width="120px"
        height="120px"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="none"
        >
          <path
            d="M616 4469 l-27 -21 3 -177 c3 -167 4 -179 30 -233 35 -74 103 -141
176 -170 l57 -23 1640 -5 1640 -5 32 -23 c111 -79 101 -243 -21 -310 -29 -16
-145 -17 -1646 -22 l-1615 -5 -47 -22 c-110 -51 -187 -161 -195 -281 -4 -58
-2 -70 16 -89 50 -52 131 -12 131 64 0 65 38 130 95 162 27 15 170 16 1645 21
l1615 5 55 26 c252 119 259 475 12 596 l-57 28 -1640 5 -1640 5 -40 23 c-22
13 -52 39 -65 59 -23 34 -25 47 -30 197 -3 100 -10 169 -17 182 -23 40 -67 45
-107 13z"
          />
          <path
            d="M203 2931 c-100 -34 -171 -114 -193 -215 -8 -36 -10 -322 -8 -956 3
-898 3 -905 24 -951 29 -61 85 -116 153 -148 l56 -26 328 0 329 0 19 24 c22
28 25 69 5 97 -14 18 -32 19 -338 24 -363 6 -365 6 -407 81 -21 37 -21 38 -19
942 3 893 3 906 23 933 11 15 36 35 55 45 33 18 106 19 1991 19 l1956 0 27 21
c34 27 35 71 1 104 l-24 25 -1963 0 c-1858 -1 -1966 -2 -2015 -19z"
          />
          <path
            d="M4407 2930 c-34 -27 -37 -78 -6 -106 19 -17 43 -19 248 -24 219 -5
227 -6 260 -29 64 -46 61 -2 61 -982 0 -886 0 -891 -21 -929 -11 -20 -35 -45
-52 -56 -31 -18 -84 -19 -1905 -24 -1840 -5 -1874 -5 -1888 -24 -21 -29 -18
-80 7 -102 21 -19 66 -19 1898 -19 l1876 0 56 26 c68 32 124 87 153 148 21 46
21 49 21 981 l0 935 -28 57 c-32 64 -80 111 -146 142 -42 19 -67 21 -276 24
-223 3 -232 3 -258 -18z"
          />
          <path
            d="M400 2587 c-51 -26 -50 -8 -47 -810 l2 -749 24 -19 c23 -19 62 -19
1601 -19 l1577 0 19 21 c18 20 19 50 22 774 l2 753 -24 29 -24 28 -1564 2
c-1241 2 -1568 0 -1588 -10z m460 -307 l0 -170 -180 0 -180 0 0 163 c0 90 3
167 7 170 3 4 84 7 180 7 l173 0 0 -170z m530 0 l0 -170 -190 0 -190 0 0 170
0 170 190 0 190 0 0 -170z m530 0 l0 -170 -190 0 -190 0 0 170 0 170 190 0
190 0 0 -170z m530 0 l0 -170 -190 0 -190 0 0 170 0 170 190 0 190 0 0 -170z
m530 0 l0 -170 -190 0 -190 0 0 170 0 170 190 0 190 0 0 -170z m470 0 l0 -170
-160 0 -160 0 0 170 0 170 160 0 160 0 0 -170z m-2792 -487 l-3 -168 -75 0
-75 0 -3 168 -2 167 80 0 80 0 -2 -167z m492 -3 l0 -170 -170 0 -170 0 0 170
0 170 170 0 170 0 0 -170z m530 0 l0 -170 -190 0 -190 0 0 170 0 170 190 0
190 0 0 -170z m530 0 l0 -170 -190 0 -190 0 0 170 0 170 190 0 190 0 0 -170z
m530 0 l0 -170 -190 0 -190 0 0 170 0 170 190 0 190 0 0 -170z m710 0 l0 -170
-280 0 -280 0 0 170 0 170 280 0 280 0 0 -170z m-2590 -485 l0 -165 -180 0
-180 0 0 165 0 165 180 0 180 0 0 -165z m530 0 l0 -165 -190 0 -190 0 0 165 0
165 190 0 190 0 0 -165z m1060 0 l0 -165 -455 0 -455 0 0 165 0 165 455 0 455
0 0 -165z m530 0 l0 -165 -190 0 -190 0 0 165 0 165 190 0 190 0 0 -165z m470
0 l0 -165 -160 0 -160 0 0 165 0 165 160 0 160 0 0 -165z"
          />
          <path
            d="M3900 2587 c-51 -26 -50 -8 -47 -810 l2 -749 24 -19 c22 -18 44 -19
431 -19 387 0 409 1 431 19 l24 19 0 761 0 760 -23 23 -23 23 -397 3 c-306 1
-403 -1 -422 -11z m330 -307 l0 -170 -115 0 -115 0 0 163 c0 90 3 167 7 170 3
4 55 7 115 7 l108 0 0 -170z m388 -2 l2 -168 -120 0 -120 0 0 170 0 171 118
-3 117 -3 3 -167z m-388 -488 l0 -171 -112 3 -113 3 -3 168 -2 167 115 0 115
0 0 -170z m388 3 l-3 -168 -117 -3 -118 -3 0 171 0 170 120 0 120 0 -2 -167z
m-388 -488 l0 -165 -115 0 -115 0 0 165 0 165 115 0 115 0 0 -165z m390 0 l0
-165 -120 0 -120 0 0 165 0 165 120 0 120 0 0 -165z"
          />
        </g>
      </svg>
    </div>
  );
};

export default KeyBoard;
